/**
 * Event Route Helper Mixin
 *
 * Provides a computed `routePrefix` and helper method `eventRoute()`
 * for dynamically generating route names based on the current service key.
 *
 * Usage in views:
 *   this.eventRoute("Application")     => "HrdcEinvoicingApplication"
 *   this.eventRoute("Settings")        => "HrdcEinvoicingSettings"
 *   this.eventRoute("SettingsEvents")  => "HrdcEinvoicingSettingsEvents"
 */
import { getEventConfig } from "@/services/hrdc_event/eventRegistry";

export default {
  watch: {
    'service.key': {
      handler(key) {
        if (key && key.startsWith("hrdc_") && key !== "hrdc") {
          this.eventStoreRestore();
        }
      },
      immediate: true,
    },
  },
  methods: {
    eventRoute(suffix) {
      const config = getEventConfig(this.service.key);
      if (config) {
        return `${config.routePrefix}${suffix}`;
      }
      return suffix;
    },
    eventStoreMutation() {
      const config = getEventConfig(this.service.key);
      if (config) {
        return config.storeMutationName;
      }
      return null;
    },
    eventStoreCommit(data) {
      const mutation = this.eventStoreMutation();
      if (mutation) {
        this.$store.commit(mutation, data);
        // Persist to localStorage since VuexPersistence doesn't handle dynamic modules
        try {
          const key = `eventStore_${this.service.key}`;
          localStorage.setItem(key, JSON.stringify(data));
        } catch (e) {
          // Ignore localStorage errors
        }
      }
    },
    eventStoreRestore() {
      // Restore event store data from localStorage if Vuex state is empty
      if (!this.service || !this.service.key) return;
      const storeData = this.$store.state[this.service.key];
      if (storeData && storeData.data && storeData.data.stageId) return; // Already has data
      try {
        const key = `eventStore_${this.service.key}`;
        const saved = localStorage.getItem(key);
        if (saved) {
          const data = JSON.parse(saved);
          const mutation = this.eventStoreMutation();
          if (mutation && data) {
            this.$store.commit(mutation, data);
          }
        }
      } catch (e) {
        // Ignore
      }
    },
  },
};
